import { useState } from "react";

export type StopRow = { key: string; color: string };

const DEFAULT_STOP_COLOR = "#888888";

export function newStopRow(color: string = DEFAULT_STOP_COLOR): StopRow {
  return { key: crypto.randomUUID(), color };
}

export function useStopRows(initial: StopRow[] = []) {
  const [stops, setStops] = useState<StopRow[]>(initial);

  const addStop = () => setStops((prev) => [...prev, newStopRow()]);

  const updateStop = (key: string, color: string) =>
    setStops((prev) =>
      prev.map((stop) => (stop.key === key ? { ...stop, color } : stop))
    );

  const removeStop = (key: string) =>
    setStops((prev) => prev.filter((stop) => stop.key !== key));

  return { stops, setStops, addStop, updateStop, removeStop };
}
